import React, { useState, useCallback } from "react";

const variantWrapClass = {
  hero: "img-skeleton-wrap img-skeleton-wrap--hero",
  work: "img-skeleton-wrap img-skeleton-wrap--work",
  "work-tall": "img-skeleton-wrap img-skeleton-wrap--work img-skeleton-wrap--work-tall",
  about: "img-skeleton-wrap img-skeleton-wrap--about",
};

/**
 * Shows a layout-matched skeleton until the image finishes loading (or errors).
 */
export function ImageWithSkeleton({
  variant = "hero",
  src,
  alt,
  width,
  height,
  className = "",
  loading,
  decoding,
  ...imgRest
}) {
  const [status, setStatus] = useState("loading");

  const onLoad = useCallback(() => setStatus("loaded"), []);
  const onError = useCallback(() => setStatus("error"), []);

  const showSkeleton = status === "loading";
  const showImg = status === "loaded" || status === "error";

  const wrapClass = variantWrapClass[variant] || variantWrapClass.hero;

  return (
    <span className={wrapClass}>
      {showSkeleton ? (
        <span className="img-skeleton" aria-hidden="true" />
      ) : null}
      <img
        src={src}
        alt={alt}
        width={width}
        height={height}
        loading={loading}
        decoding={decoding}
        onLoad={onLoad}
        onError={onError}
        className={`${className} ${showImg ? "img-skeleton-wrap__img--visible" : "img-skeleton-wrap__img--hidden"}`.trim()}
        {...imgRest}
      />
    </span>
  );
}

export default ImageWithSkeleton;
